<span class="sun-line__glyph" [style.color]="glyphColor" aria-hidden="true">{{ glyph }}</span>
@for (part of day().parts; track part.fromMs) {
  <span class="sun-line__line" [class.is-dominant]="part.dominant" aria-hidden="true">{{ part.line }}</span>
}
@if (marker(); as marker) {
  <i class="sun-line__marker fa-solid fa-{{ marker.icon }}" [class.sun-line__marker--quarter]="marker.kind === 'quarter'" aria-hidden="true"></i>
}
